import { useState } from "react";
import { Button } from "semantic-ui-react";

import { PONOvisModal } from "modules/AppointmentDetails/components/PonOvis/components/PONOvisModal";
import { usePonOvis } from "modules/AppointmentDetails/components/PonOvis/hooks/usePonOvis";
import "modules/AppointmentDetails/components/PonOvis/PonOvis.scss";

type PonOvisProps = {
  car_id?: number;
  hasOvisData: boolean;
};

export type PonOvisEvent = {
  masterDataSource: string;
  commissionYear: string | null;
  commissionNumber: string | null;
  vin: string;
  shortVin: string | null;
  licensePlate: string;
  eventTypeCode: string;
  eventTypeEN: string;
  eventTypeNL: string;
  eventStatusCode: string;
  eventStatus: string;
  eventSequence: string;
  eventDate: string;
  info: string;
  created: string;
  modified: string;
};

export const PonOvis = ({ car_id, hasOvisData }: PonOvisProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);

  const { data, isLoading } = usePonOvis({ isModalOpen, car_id });

  const handleOpenModal = () => setIsModalOpen(true);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setPage(1);
  };

  const handleGoToNextPage = () => setPage(page + 1);
  const handleGoToPreviousPage = () => setPage(page - 1);

  return (
    <>
      <Button className={`-appointment-status ${hasOvisData ? "pon-ovis-button-has-data" : ""}`} size="small" onClick={handleOpenModal} loading={isLoading}>
        OVIS
      </Button>
      <PONOvisModal
        events={data}
        isOpen={isModalOpen && !isLoading}
        onClose={handleCloseModal}
        onGoToNextPage={handleGoToNextPage}
        onGoToPreviousPage={handleGoToPreviousPage}
        page={page}
      />
    </>
  );
};
